export const ADMIN = {
  shell: "admin-shell",
  navDashboard: "admin-nav-dashboard",
  navMessages: "admin-nav-messages",
  navUsers: "admin-nav-users",
  navCredits: "admin-nav-credits",
  navPayments: "admin-nav-payments",
  navAi: "admin-nav-ai",
  navPricing: "admin-nav-pricing",
  navContent: "admin-nav-content",
  navHelp: "admin-nav-help",
  navSettings: "admin-nav-settings",
  entryLink: "admin-entry-link",
  metricUsers: "admin-metric-users",
  metricCredits: "admin-metric-credits",
  metricRevenue: "admin-metric-revenue",
  metricAiCost: "admin-metric-aicost",
  metricMessages: "admin-metric-messages",
  messagesTable: "admin-messages-table",
  messageRow: "admin-message-row",
  messageStatusSelect: "admin-message-status-select",
  messageSaveButton: "admin-message-save-button",
  usersTable: "admin-users-table",
  userRow: "admin-user-row",
  userSearch: "admin-user-search",
  userDetail: "admin-user-detail",
  userBlockButton: "admin-user-block-button",
  userDeleteButton: "admin-user-delete-button",
  userRestoreButton: "admin-user-restore-button",
  userRoleButton: "admin-user-role-button",
  creditAdjustAmount: "admin-credit-adjust-amount",
  creditAdjustReason: "admin-credit-adjust-reason",
  creditAdjustSubmit: "admin-credit-adjust-submit",
  paymentsTable: "admin-payments-table",
  aiTable: "admin-ai-table",
  pricingTable: "admin-pricing-table",
  pricingSave: "admin-pricing-save",
  packsTable: "admin-packs-table",
  contentTable: "admin-content-table",
  settingsFlags: "admin-settings-flags",
  flagToggle: "admin-flag-toggle",
  ledgerTable: "admin-ledger-table",
  walletsTable: "admin-wallets-table",
  creditsTab: "admin-credits-tab",
  ledgerAdjustEmail: "admin-ledger-adjust-email",
  ledgerAdjustAmount: "admin-ledger-adjust-amount",
  ledgerAdjustReason: "admin-ledger-adjust-reason",
  ledgerAdjustSubmit: "admin-ledger-adjust-submit",
  auditTable: "admin-audit-table",
  emailEventsTable: "admin-email-events-table",
  testEmailInput: "admin-test-email-input",
  testEmailSubmit: "admin-test-email-submit",
  settingsTab: "admin-settings-tab",
  pricingTab: "admin-pricing-tab",
  packsSave: "admin-packs-save",
  faqAddCategory: "admin-faq-add-category",
  faqAddArticle: "admin-faq-add-article",
  faqArticleRow: "admin-faq-article-row",
  faqEditSave: "admin-faq-edit-save",
  faqPublishToggle: "admin-faq-publish-toggle",
  navCms: "admin-nav-cms",
  cmsCatalog: "admin-cms-catalog",
  cmsPromptRow: "admin-cms-prompt-row",
  cmsNewVersion: "admin-cms-new-version",
  cmsNewPrompt: "admin-cms-new-prompt",
  cmsVersionRow: "admin-cms-version-row",
  cmsEditor: "admin-cms-editor",
  cmsSave: "admin-cms-save",
  cmsAutofill: "admin-cms-autofill",
  cmsQa: "admin-cms-qa",
  cmsPreview: "admin-cms-preview",
  cmsPublish: "admin-cms-publish",
  cmsStatusSelect: "admin-cms-status-select",
  cmsReviewQueue: "admin-cms-review-queue",
  cmsQueueRow: "admin-cms-queue-row",
  cmsQueueTab: "admin-cms-queue-tab",
  cmsCatalogTab: "admin-cms-catalog-tab",
  cmsPublishedTab: "admin-cms-published-tab",
  cmsPublishedList: "admin-cms-published-list",
  cmsQueueSelectAll: "admin-cms-queue-select-all",
  cmsQueueRowCheck: "admin-cms-queue-row-check",
  cmsBulkAcceptButton: "admin-cms-bulk-accept-button",
  cmsBulkConfirmDialog: "admin-cms-bulk-confirm-dialog",
  cmsBulkConfirmButton: "admin-cms-bulk-confirm-button",
  cmsBulkCancelButton: "admin-cms-bulk-cancel-button",
};
